export default "__VITE_ASSET__CKbBgq2h__"